import Vue from "vue";
import Vuex from "vuex";
import contacts from "./contacts";
import users from "./users";
import appointments from "./appointments"
import appointmentTenants from "./appointmentTenants"
import applications from "./applications"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    contacts,
    users,
    appointments,
    appointmentTenants,
    applications
  }
});
